import React from 'react';

const cardTypes = [
  { key: 'total_applicants', label: 'Total Applicants', className: 'primary' },
  { key: 'attended_meet_greet', label: 'Attended Meet & Greet', className: 'success' },
  { key: 'registered_startupworld', label: 'Registered', className: 'info' },
  { key: 'assigned_project', label: 'Assigned Project', className: 'secondary' },
  { key: 'rejected', label: 'Rejected', className: 'danger' },
  { key: 'left', label: 'Left', className: 'warning' }
];

const StatsGrid = ({ stats }) => (
  <div className="stats-grid">
    {cardTypes.map(card => (
      <div key={card.key} className={`stat-card ${card.className}`}>
        <div className="stat-content">
          <h3>{stats[card.key] || 0}</h3>
          <p>{card.label}</p>
        </div>
      </div>
    ))}
  </div>
);

export default StatsGrid;